"use client";
import React from "react";
import { HeroSection } from "./HeroSection";
import { SparklesText } from "./SparklesText";

export function Hero() {
  return (
    <section id="home" className="relative overflow-hidden">
      <HeroSection
        title="Dedox — On-chain Perp & DeFi Protocol"
        subtitle={{ regular: "Built on Hedera, live on ", gradient: "Hedera Testnet" }}
        description="Trade perpetuals with confidence. Low fees, fast finality, and secure execution on Hedera."
        ctaText="Open trading"
        ctaHref="https://app.dedox.xyz"
        className="py-0"
      />
      
    </section>
  );
}


